// react
import styled from 'styled-components';
import { css } from 'styled-components';

// icons
import { Icon } from '@/components/atoms';
import { Icons } from '../Icon';

/**
 * Chip is a component that displays a chip.
 */
export const Chip = ({
  label,
  isSelected = false,
  onClick,
  icon,
  isDisabled = false,
}: ChipProps) => {
  return (
    <StyledChip
      onClick={onClick}
      $isButton={!!onClick}
      $isSelected={isSelected}
      $isDisabled={isDisabled}
    >
      {icon && <Icon icon={icon} />} <Label>{label}</Label>
    </StyledChip>
  );
};

interface StyledChipProps {
  $isButton?: boolean;
  $isSelected?: boolean;
  $isDisabled?: boolean;
}
const StyledChip = styled.div<StyledChipProps>`
  display: inline-flex;
  align-items: center;
  gap: ${(props) => props.theme.spacing[8]};
  background: ${(props) => props.theme.color.neutral[30]};
  border-radius: 99999px;
  padding: ${(props) => props.theme.spacing[8]}
    ${(props) => props.theme.spacing[16]};
  color: ${(props) => props.theme.color.neutral[90]};
  user-select: none;
  white-space: nowrap;
  transition-duration: 200ms;

  ${(props) =>
    props.$isButton &&
    !props.$isSelected &&
    css`
    cursor: pointer;
    &:hover {
      background: ${props.theme.color.neutral[90]};
      color: ${props.theme.color.neutral[10]};
  `}

  ${(props) =>
    props.$isSelected &&
    css`
      cursor: default;
      pointer-events: none;
      background: ${props.theme.color.neutral[90]};
      color: ${props.theme.color.neutral[10]};
    `}

  ${(props) =>
    props.$isDisabled &&
    css`
      background: ${props.theme.color.neutral[30]};
      color: ${props.theme.color.neutral[50]};
      cursor: default;
    `}
`;

const Label = styled.div`
  font: ${(props) => props.theme.typography.body.sm.regular};
`;

export interface ChipProps {
  label: string;
  onClick?: () => void;
  isSelected?: boolean;
  icon?: Icons;
  to?: string;
  isDisabled?: boolean;
}

Chip.displayName = 'Chip';

export default Chip;
